<template>
    <v-form ref="form" v-model="valid" lazy-validation style="height:875px;">
        <v-card class="overflow-x-hidden system_dialog_color system_admin_font_family_primary">
            <v-card-title class="pa-3 pl-3 pb-0 border-bottom system_dialog_color" >
                <span class="h5 system_dialog_font_color pl-4">Raffle Prize Details</span>
                <v-row class="m-0">
                    <v-col cols="pull-right-10 p-2">
                        <v-btn
                            text
                            icon
                            small
                            color="gray"
                            class="float-right"
                            @click="closeDialog()"
                        >
                            <span class="system_dialog_font_color"><v-icon>mdi-close-circle</v-icon></span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="system_dialog_color">
                <v-container class="pb-0 mt-1 " fluid>
                    <v-row no-gutters class="pa-0">
                        <v-col cols="12" class="pa-0 pb-2">
                            <v-hover v-model="isHover">
                                <template v-slot="{ hover }">
                                    <v-card class="ma-4">
                                        <v-container fluid class="picture">
                                            <v-img :src="form.prize_image ? form.prize_image : checkImagePath(form.image_path)" contain aspect-ratio="1.7">
                                            </v-img>
                                        </v-container>
                                        <v-fade-transition style="opacity:0.5;">
                                            <v-overlay absolute :color="hover ? 'white' : ''"  class="d-flex flex-row justify-content-center align-items-center">
                                                    <v-row>
                                                        <v-tooltip bottom color="#2590ff">
                                                            <template v-slot:activator="{ on, attrs }" >
                                                                <v-btn
                                                                    v-show="hover == true"
                                                                    v-on="on"
                                                                    v-bind="attrs"
                                                                    :disabled="disabled_view"
                                                                    style="opacity:1; cursor: pointer;"
                                                                    class="ma-2 "
                                                                    color="#2590ff"
                                                                    text
                                                                >
                                                                    <label for="upload-file"><span class="upload-file system_dialog_font_color"><v-icon x-large>mdi-tray-arrow-up</v-icon></span></label>
                                                                </v-btn>
                                                            </template>
                                                            <span>Upload Image</span>
                                                        </v-tooltip>
                                                    </v-row>
                                                <input  class="d-none" id="upload-file" type="file" ref="fileInput" @change="uploadImage" accept="image/png, image/jpeg"/>
                                            </v-overlay>
                                        </v-fade-transition>
                                    </v-card>
                                </template>
                            </v-hover>
                        </v-col>
                        <v-col cols="12" class="pa-1">
                            <v-text-field
                                v-model="form.code"
                                :disabled="disabled_view"
                                label="Code"
                                :rules="errors.required"
                                outlined
                                class="system_dialog_text_color"
                                required
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-1">
                            <v-text-field
                                v-model="form.name"
                                :rules="errors.required"
                                :disabled="disabled_view"
                                label="Name"
                                class="system_dialog_text_color"
                                outlined
                                required
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-1">
                            <v-autocomplete
                                v-model="form.tenure_categories"
                                :rules="errors.required"
                                :items="dropdowns.tenure_categories"
                                :disabled="disabled_view"
                                label="Tenure Categories"
                                class="system_dialog_text_color"
                                item-text="text"
                                item-value="value"
                                auto-select-first
                                deletable-chips
                                small-chips
                                clearable
                                multiple
                                outlined
                                required
                                dense
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="pa-1">
                            <v-autocomplete
                                v-model="form.raffle_group_id"
                                :rules="errors.required"
                                :items="GET_RAFFLE_GROUP_SELECTION"
                                :disabled="disabled_view"
                                label="Raffle Group"
                                class="system_dialog_text_color"
                                item-text="name"
                                item-value="id"
                                auto-select-first
                                clearable
                                outlined
                                required
                                dense
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="pa-1" v-if="ACTION != 'Submit' && raffleSettings.data_grouping == 2">
                            <v-autocomplete
                                v-model="form.ticket_num"
                                :items="dropdowns.company_tickets"
                                :rules="errors.required"
                                :disabled="disabled_view"
                                item-text="value"
                                label="Winner Ticket #"
                                class="system_dialog_text_color"
                                clearable
                                outlined
                                dense
                                @input="getCompanyNameOfTicket()"
                                :item-disabled="checkItemDisabled"                            
                                >
                            </v-autocomplete>
                            <!-- <v-text-field
                                v-model="form.ticket_num"
                                :disabled="disabled_view"
                                label="Winner Ticket #"
                                class="system_dialog_text_color"
                                readonly
                                outlined
                                required
                                dense
                            ></v-text-field> -->
                        </v-col>
                        <v-col cols="12" class="pa-1" v-if="ACTION != 'Submit' && raffleSettings.data_grouping == 2">
                            <v-text-field
                                v-model="form.company_name"
                                :disabled="disabled_view"
                                label="Winner Company Name"
                                :rules="errors.required"
                                class="system_dialog_text_color"
                                readonly
                                outlined
                                required
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-1" v-if="ACTION != 'Submit' && raffleSettings.data_grouping == 1">
                            <v-text-field
                                v-model="form.employee_id"
                                :disabled="disabled_view"
                                label="Employee ID"
                                class="system_dialog_text_color"
                                readonly
                                :rules="errors.required"
                                outlined
                                required
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-1" v-if="ACTION != 'Submit' && raffleSettings.data_grouping == 1">
                            <v-text-field
                                v-model="form.guest_name"
                                :disabled="disabled_view"
                                label="Guest Name"
                                class="system_dialog_text_color"
                                readonly
                                :rules="errors.required"
                                outlined
                                required
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                            <v-text-field
                                v-model="form.winner_count"
                                :rules="errors.required"
                                :disabled="disabled_view"
                                label="Winner Count"
                                type="number"
                                class="system_dialog_text_color"
                                min="0"
                                hide-spin-buttons
                                outlined
                                required
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                            <v-text-field
                                v-model="form.order"
                                label="Order"
                                type="number"
                                min="0"
                                class="system_dialog_text_color"
                                :disabled="disabled_view"
                                readonly
                                outlined
                                :rules="errors.required"
                                required
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                            <v-text-field
                                v-model="form.batch"
                                :disabled="disabled_view"
                                label="Batch"
                                class="system_dialog_text_color"
                                type="number"
                                min="1"
                                hide-spin-buttons
                                outlined
                                required
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-1">
                            <v-checkbox
                                v-model="form.suspense_animate"
                                :true-value="1"
                                :false-value="0"
                                :disabled="disabled_view"
                                label="Suspense Animation"
                                class="system_dialog_text_color"
                                outlined
                                required
                                dense
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions
                class="text-center system_dialog_color"
                style="border-top: 1px solid #000000"
            >
                <v-row class="ma-1 pb-2">
                    <v-col cols="12" v-if="actions != 'View'">
                        <v-btn
                            @click="actions == 'Submit' ? addRafflePrize() : updateRafflePrize()"
                            :disabled="disabled_view"
                            class="system_dialog_button_color"
                        >
                            <span class="system_dialog_font_color">{{ actions }}</span>
                        </v-btn>
                        <span class="pr-12">&nbsp;</span>
                    </v-col>
                    <v-row justify="center" cols="12" v-if="actions === 'View'">
                        <v-col>
                    <v-btn 
                                color="primary" 
                                @click="viewVoidedHistory" 
                                :disabled="!hasVoidedHistory"
                            >
                                Voided History
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col  >
                        <v-btn
                            @click="voidRafflePrize"
                            color="red"
                            class="system_dialog_button_color"
                            v-show="!isVoidButtonDisabled"
                        >
                            <span class="system_dialog_font_color">Void</span>
                        </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    </v-row>
                    <template v-if="actions === 'View'">
                        <v-container>
                            
                                <v-dialog v-model="dialog" persistent max-width="800px">
                                    <v-card>
                                        <v-card-title class="headline">Voided History</v-card-title>
                                    <v-card-text>
                                        <v-data-table
                                            v-if="ACTION !== 'Submit' && raffleSettings.data_grouping == 1"
                                            :headers="guestHeaders"
                                            :items="voidedHistory"
                                            item-key="winner_id"
                                            class="elevation-1"
                                            :items-per-page="voidedHistory.length"
                                            hide-default-footer
                                            dense
                                            :loading="loadingGuestHistory"
                                            loading-text="Loading guest history..."
                                        >
                                            <template v-slot:item="props">
                                                <tr>
                                                    <td>{{ props.item.guest_name }}</td>
                                                    <td>{{ props.item.type }}</td>
                                                    <td>{{ props.item.time_voided }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                        <span v-if="!loadingGuestHistory && ACTION !== 'Submit' && raffleSettings.data_grouping == 1 && !voidedHistory.length" type="info">
                                            No guest data available
                                        </span>
                                        <v-data-table
                                            v-if="ACTION !== 'Submit' && raffleSettings.data_grouping == 2"
                                            :headers="companyHeaders"
                                            :items="companyHistory"
                                            item-key="ticket_num"
                                            class="elevation-1"
                                            :items-per-page="companyHistory.length"
                                            hide-default-footer
                                            dense
                                            :loading="loadingCompanyHistory"
                                            loading-text="Loading company history..."
                                        >
                                            <template v-slot:item="props">
                                                <tr>
                                                    <td>{{ props.item.company_name }}</td>
                                                    <td>{{ props.item.ticket_num }}</td>
                                                    <td>{{ props.item.type }}</td>
                                                    <td>{{ props.item.time_voided }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                        <span v-if="!loadingCompanyHistory && ACTION !== 'Submit' && raffleSettings.data_grouping == 2 && !companyHistory.length" type="info">
                                            No company data available
                                        </span>
                                        </v-card-text>
                                    <v-card-actions>
                                        <v-btn 
                                            text 
                                            @click="dialog = false" 
                                            class="system_dialog_font_color" 
                                            style="position: absolute; top: 10px; right: 10px;">
                                            <v-icon left>mdi-close-circle</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-container>
                    </template>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import SharedFunctionsComponent from "@/components/shared/SharedFunctionsComponent.vue";
export default {
    mixin: [SharedFunctionsComponent],
    data() {
        return {
            baseUrlAPI: {
                get: "rafflePrizes"
            },
            voidedHistory: [],
            companyHistory: [],
            dialog: false,
            hasVoidedHistory: false,
            loadingGuestHistory: false,
            loadingCompanyHistory: false,
            guestHeaders: [],
            companyHeaders: [],
            headers: [],
            valid: false,
            overlay: false,
            disabled_view: false,
            errors: {
                required: [(v) => !!v || "Field is required"],
                number: [
                    (v) => !!v || "Cost is required",
                    (v) => !isNaN(v) || "Input must be a number",
                ],
            },
            form: {},
            isHover: false,
            raffleSettings: {
				data_grouping: null
			},
            dropdown_function_name: [
                'getCompanyTickets',
                'getTenureCategories'
            ],
            dropdowns:{
                company_tickets: [],
                guest_lists: [],
                tenure_categories: []
            },
            company_id_winners: [],
            errors: {
                required: [v => !!v || 'The field is required.'],
                code: [v => !!v || 'The code is required'],
                name: [v => !!v || 'The name is required'],
                order: [v => !!v || 'The order is required'],
                winner_count: [v => !!v || 'The winner_count is required'],
                guest_name: [v => !!v || 'The guest_name is required'],
                employee_id: [v => !!v || 'The employee_id is required'],
                company_name: [v => !!v || 'The company_name is required'],
                ticket_num: [v => !!v || 'The ticket_num is required'],
                tenure_categories: [v => !!v || 'The tenure_categories is required'],
            },
            winner_ids: [],
        };
    },
    computed: {
        ...mapGetters([
            "ACTION",
            "DIALOGS",
            "GET_DIALOG_VIEW",
            "GET_EVENT_ID",
            "GET_RAFFLE_GROUP_SELECTION",
        ]),
        actions() {
            this.getDropdowns();
            if (this.ACTION == "Submit") {
                this.disabled_view = false;
                this.isViewBtn = false;
                this.getLatestOrderPrizes();
                return "Submit";
            } else if (this.ACTION == "Update") {
                this.disabled_view = false;
                this.isViewBtn = true;
                this.getRafflePrizeData();
                return "Update";
            } else if (this.ACTION == "View") {
                this.disabled_view = true;
                this.isViewBtn = true;
                this.getRafflePrizeData();
                return "View";
            } 
        },
        isVoidButtonDisabled() {
            if (this.raffleSettings.data_grouping === 1) {
                return !this.form.guest_name;
            } else if (this.raffleSettings.data_grouping === 2) {
                return !this.form.company_name;
            }
            return true; 
        }
    },
    created() {
        this.initialForm();
    },
    mounted() {
        this.getRaffleDurationSettings();
        this.checkVoidedHistory();
        this.getWinnersTicket();
    },
    methods: {
        initialForm() {
            this.form = {
                code                : '',
                name                : '',
                order               : '',
                prize_image         : null,
                image_path          : null,
                suspense_animate    : 0,
                batch               : 1,
                raffle_group_id     : 1,
                tenure_categories   : []
            };
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = null;
            }
        },
        height(width) {1
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    return "100%";
                case "sm":
                    return "100%";
                case "md":
                    return width;
                case "lg":
                    return width;
                case "xl":
                    return width;
            }
        },
        closeDialog() {
            this.$store.commit("DIALOG", false);
            this.$store.commit("ACTION", null);
            this.winner_ids = [];
        },
        async addRafflePrize() {
            this.$refs.form.validate();
            let code_swal_text = this.form.code ? '' : 'Code';
            let name_swal_text = this.form.name ? '' : 'Name';
            let winner_count_swal_text = this.form.winner_count ? '' : 'Winner Count';
            let order_swal_text = this.form.order ? '' : 'Order';
            let file_swal_text = '';
            const file = this.$refs.fileInput.files[0];
            if (!file) {
                file_swal_text = 'Prize Image';
            } else if (!['image/png', 'image/jpeg'].includes(file.type)) {
                file_swal_text = 'Valid Image (PNG or JPEG)';
            } else if (file.size > 2 * 1024 * 1024) {
                file_swal_text = 'Image below 2 MB';
            }

            let array_text = [
                code_swal_text,
                name_swal_text,
                order_swal_text,
                winner_count_swal_text,
                file_swal_text,
            ];
            let filtered = array_text.filter((el) => el).join(', ');

            if (
                this.form.code &&
                this.form.name &&
                this.form.order &&
                this.form.winner_count &&
                !file_swal_text 
            ) {
                let payload = {
                    url: "rafflePrizes",
                    ...this.form,
                    event_id: this.GET_EVENT_ID,
                };

                await this.$store.dispatch('urlPost', payload).then(async (response) => {
                    Swal.fire(
                        response.icon.toUpperCase(),
                        response.message,
                        response.icon
                    );
                    this.$store.commit('NEW_MASTER_DATA', true);
                    
                    // Get latest order prize after successful submission
                        await this.getLatestOrderPrizes();
                        // Reset form fields but keep the updated order
                        this.form.code = '';
                        this.form.name = '';
                        this.form.prize_image = null;
                        this.form.image_path = null;
                        this.form.suspense_animate = 0;
                        this.form.batch = 1;
                        this.form.raffle_group_id = 1;
                        this.form.tenure_categories = [];
                        this.form.winner_count = '';
                        if (this.$refs.fileInput) {
                            this.$refs.fileInput.value = null;
                        }
                        // Keep dialog open for adding another prize
                    this.$store.commit("DIALOG", false);
                });
            } else {
                Swal.fire({
                    text: `Fill Required Fields (${filtered})`,
                    icon: 'warning',
                    allowOutsideClick: false,
                });
            }
        },
        async updateRafflePrize() {
            // if (!this.form.ticket_num) {
            //     Swal.fire({
            //         title: 'Winner Ticket Cannot Be Null',
            //         text: 'Please void the winner.',
            //         icon: 'warning'
            //     });
            //     return; 
            // }

            let payload = {
                url: "rafflePrizes",
                id: this.form.id,
                ...this.form,
                event_id: this.GET_EVENT_ID
            };

            try {
                const response = await this.$store.dispatch("urlPut", payload);
                this.$store.commit('NEW_MASTER_DATA', true)
                this.closeDialog();
                const swalInstance = await Swal.fire({
                    title: response.icon.toUpperCase(),
                    text: response.message,
                    icon: response.icon,
                    showConfirmButton: true,   
                    allowOutsideClick: false,  
                    focusConfirm: true         
                });

                if (swalInstance.isConfirmed) {
                    Swal.close();
                }

            } catch (error) {
                if (error.response && error.response.status === 401) {
                    await Swal.fire({
                        title: 'Unauthenticated!',
                        text: 'Please log in again.',
                        icon: 'error',
                        allowOutsideClick: false
                    });

                    localStorage.removeItem("token");
                    this.$router.push('/');

                } else {
                    await Swal.fire({
                        title: 'Error!',
                        text: 'Something went wrong. Please try again.',
                        icon: 'error'
                    });
                }
            }
        },
        async getRafflePrizeData() {
            this.getWinnersTicket();
            this.form.id                    = this.GET_DIALOG_VIEW.id;
            this.form.code                  = this.GET_DIALOG_VIEW.code;
            this.form.name                  = this.GET_DIALOG_VIEW.name;
            this.form.winner_count          = this.GET_DIALOG_VIEW.winner_count;
            this.form.order                 = this.GET_DIALOG_VIEW.order;
            // this.form.prize_image           = this.GET_DIALOG_VIEW.prize_image;
            this.form.image_path            = this.GET_DIALOG_VIEW.image_path;
            this.form.suspense_animate      = this.GET_DIALOG_VIEW.suspense_animate;
            this.form.tenure_categories     = this.GET_DIALOG_VIEW.tenure_categories;
            this.form.batch                 = this.GET_DIALOG_VIEW.batch;
            this.form.raffle_group_id       = this.GET_DIALOG_VIEW.raffle_group_id;
            if(!_.isEmpty(this.GET_DIALOG_VIEW.winner_details)){
                if(this.raffleSettings.data_grouping == 1){
                    this.form.employee_id   = this.GET_DIALOG_VIEW.winner_details.reference_number;
                    this.form.guest_name    = this.GET_DIALOG_VIEW.winner_details.full_name;
                }else{
                    this.form.company_name  = this.GET_DIALOG_VIEW.winner_details.name;
                    this.form.ticket_num    = this.GET_DIALOG_VIEW.winner_details.ticket_num;
                }
            }
        },
        async checkVoidedHistory() {
            try {
                const response = await this.$store.dispatch('urlGet', {
                    url: 'voidedHistory',
                    params: { event_id: this.GET_EVENT_ID },
                });

                if (response.icon === 'success' && response.data && response.data.length > 0) {
                    this.hasVoidedHistory = true; 
                } else {
                    this.hasVoidedHistory = false; 
                }
            } catch (error) {
                console.error('Error fetching voided history:', error);
                this.hasVoidedHistory = false; 
            }
        },
        async voidRafflePrize() {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to void this raffle prize?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, void it!',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
            });

            if (result.isConfirmed) {
                try {
                    let payload = {
                        url: 'rafflePrizes/void',  
                        id: this.form.id,
                        event_id: this.GET_EVENT_ID,
                    };

                    const response = await this.$store.dispatch('urlPut', payload);
                    Swal.fire(response.icon.toUpperCase(), response.message, response.icon);

                    if (response.icon === 'success') {
                        this.closeDialog(); 
                        this.$store.commit('NEW_MASTER_DATA', true);
                        this.hasVoidedHistory = true;
                        this.getWinnersTicket();
                     }
                } catch (error) {
                    Swal.fire('Error', 'An error occurred while trying to void the prize', 'error');
                }
            }
        },
        async viewVoidedHistory() {
            this.dialog = true;
            this.loadingGuestHistory = true; 
            this.loadingCompanyHistory = true;
            try {
                const response = await this.$store.dispatch('urlGet', {
                    url: 'voidedHistory',
                    params: { event_id: this.GET_EVENT_ID },
                });

                if (response.icon === 'success' && response.data) {
                    this.voidedHistory = response.data.filter(item => item.type === 'guest').map(winner => ({
                        guest_name: winner.guest_name,
                        type: winner.type,
                        time_voided: winner.time_voided,
                    }));

                    this.companyHistory = response.data.filter(item => item.type === 'company').map(winner => ({
                        company_name: winner.company_name,
                        ticket_num: winner.ticket_num,
                        type: winner.type,
                        time_voided: winner.time_voided,
                    }));
                    if (this.voidedHistory.length > 0) {
                        const firstItem = this.voidedHistory[0];
                        this.guestHeaders = Object.keys(firstItem).map(key => ({
                            text: key.replace('_', ' ').toUpperCase(),
                            value: key,
                        }));
                    }

                    if (this.companyHistory.length > 0) {
                        const firstItem = this.companyHistory[0];
                        this.companyHeaders = Object.keys(firstItem).map(key => ({
                            text: key.replace('_', ' ').toUpperCase(),
                            value: key,
                        }));
                    }
                } else {
                    this.voidedHistory = []; 
                    this.companyHistory = [];
                }
            } catch (error) {
                console.error('Error fetching voided history:', error);
            } finally {
                this.loadingGuestHistory = false; 
                this.loadingCompanyHistory = false; 
            }
        },
        uploadImage(event) {
            let that = this;
			let reader = new FileReader()
			reader.addEventListener('load', () => {
				that.form.prize_image = reader.result
			})
			let file = event.target.files[0];
			let url = reader.readAsDataURL(file);
		},
        getLatestOrderPrizes(){
            let payload = {
                url: 'getLatestOrderPrizes'
            }
            this.$store.dispatch('urlPost', payload).then((res)=>{
                this.form.order = res;
            }).catch((error)=>{
                if(error.response.status == 401){
                    Swal.fire({
                        title: 'Unauthenticated!',
                        text: '',
                        icon: 'error',
                        allowOutsideClick: false
                    }).then((result)=>{
                        if(result.isConfirmed){
                            localStorage.removeItem("token");
                            window.location.reload();
                            this.$router.push('/');
                        }
                    })
                }
            });
        },
        async getRaffleDurationSettings(){
			let payload = {
                type: 'Expansions',
                url: 'moduleSettings'
            };
            await this.$store.dispatch("urlGet", payload).then((res)=>{
                res.forEach(e=>{
                    Object.keys(this.raffleSettings).filter(el=>{
                        if(el == e.parameter){
                            this.raffleSettings[el] = parseFloat(e.value)
                        }
                    });
                })
            })
		},
        getDropdowns(){
            this.dropdown_function_name.forEach(e=>{
                this[e]();
            })
        },
        getCompanyTickets(){
            let payload = {
                url: 'getCompanyTickets',
            }
            this.$store.dispatch('urlPost', payload).then(res=>{
                this.dropdowns.company_tickets = res.lists
                this.company_id_winners = res.company_id_winners
            })
        },
        getCompanyNameOfTicket(){
            let ticket_company_name = this.dropdowns.company_tickets.find(x=> x.value == this.form.ticket_num)?.company_name;
            this.form.company_name = ticket_company_name
            this.$forceUpdate();
        },
        checkExistingWinnerCompany(item){
            if(this.company_id_winners.includes(item.company_id)){
                return true
            }
            return false
        }, 
        getTenureCategories(){
            let payload = {
                url: 'getTenureCategories',
            }
            this.$store.dispatch('urlPost', payload).then(res=>{
                this.dropdowns.tenure_categories = res;
            })
        },
        
        checkItemDisabled(item) {
            if (this.winner_ids.map(e => e.winner_id).includes(item.value) 
            && 
            !this.winner_ids.map(r => r.prize_id).includes(this.form.id)) {
                return true;
            } else {
                return false;
            }   
        },
        async getWinnersTicket(){
            let payload = {
                url: 'getWinnersTicket',
            }
            await this.$store.dispatch('urlPost', payload).then(res => {
                this.winner_ids = res;
            })
        },
        checkImagePath(image_path) {
            return image_path == null
                ? process.env.VUE_APP_API_HOST + "/images/no-image.png"
                : process.env.VUE_APP_API_HOST + "/" + image_path
        },
    },
    watch: {
        DIALOGS: {
            handler(val) {
                if (!val) {
                    this.initialForm();
                    this.$store.commit('DIALOG_VIEW', {});
                }else{
                    // if(this.ACTION == 'Submit'){
                        //this.getLatestOrderPrizes()
                    // }
                }
            },
        },
        ACTION: {
            handler(val) {
                if (val == 'Submit') {
                    this.getLatestOrderPrizes();
                }
            },
        },
    },
};
</script>

<style scoped>
    .modal_title {
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: white;
    }
</style>
